import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UnauthorizedPage from './UnauthorizedPage'; // We'll create this next

const ProtectedRoute = ({ children, requiredPage }) => {
  const { user } = useSelector((state) => state.auth);

  // If no user is logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isAdmin = user?.type === "ADMIN";
  const allowedPages = isAdmin ? ["all"] : (user?.allowed_pages || []);

  // Check if user has access to this page
  const hasAccess = isAdmin || allowedPages.includes("all") || allowedPages.includes(requiredPage);

  if (!hasAccess) {
    return <UnauthorizedPage />;
  }

  return children;
};

export default ProtectedRoute;